import { render } from "./WhySkyHome.vue?vue&type=template&id=6ef687d8"
const script = {}

import "./WhySkyHome.vue?vue&type=style&index=0&id=6ef687d8&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__